<div class="theme-static">
  <section class="header position-fixed w-100">
    <app-common-header></app-common-header>
  </section>

  <!-- End Header Part -->

  <!-- Start Page Header Title Part -->
  <section class="page-header-title">
    <div class="page-title-overlay"></div>
    <img
      src="assets/images/w2c/page-header/faqs.jpg"
      alt=""
      class="w-100 page-title-image"
    />
    <div class="page-header-title-caption">
      <h1>Mt Lewotobi Eruption Travel Insurance Updates</h1>
    </div>
  </section>
  <!-- End Page Ttile  -->

  <!-- Main Content -->
  <main class="page-content py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-content-info">
            <h3>
              Mount Lewotobi Laki-Laki volcanic eruption event – flight
              disruptions to and from Bali, effective 2pm (AEDT) on 18th June
              2025
            </h3>

            <p class="text-dark">
              <strong
                >This travel alert is no longer active and will not impact
                coverage for a new policy purchase.</strong
              >
            </p>
            <p>
              As a result of the volcanic eruption on Mount Lewotobi Laki-Laki
              in June 2025, the spread of volcanic ash is impacting flight paths
              with many flights to and from Bali cancelled due to safety
              concerns. Please check with your airline if your travel plans have
              been affected due to this volcanic activity.
            </p>
            <p>
              As a result of the volcanic eruption on Mount Lewotobi Laki-Laki
              in June 2025, the spread of volcanic ash is impacting flight paths
              with many flights to and from Bali cancelled due to safety
              concerns. Please check with your airline if your travel plans have
              been affected due to this volcanic activity.
            </p>
            <p>
              If you have a travel insurance policy with us and have been
              impacted by this event, please contact our claims team. The
              contact details are located on the website under 'How to Claim'
              You have the option to contact the claims team by phone or lodge a
              claim using the online portal.
            </p>
          </div>

          <div class="page-content-info">
            <p>
              <b
                >Please note that you will only be covered for this event if you
                have purchased a policy before 2pm (AEDT) on 18th June 2025.</b
              >
            </p>
            <p>
              If you have purchased a policy after the above time and are
              intending to travel while this event continues to disrupt travel
              to and from Bali, you will not be covered for anything related to
              this volcanic event, in accordance with the terms of your travel
              insurance policy.
            </p>
            <p>
              We will continue to monitor the situation and may update this
              travel advice.
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>
